'use client';

import { type ReactNode } from 'react';
import {
  MOBILE_TEAM_MODAL_DEBUG_FEATURE,
  MOBILE_TEAM_MODAL_DEBUG_INSTANCE_ID,
  MobileModalDebugSource,
} from '@/hooks/telemetry/mobile-modal-debug';
import { usePersistentDebugLogger } from '@/hooks/telemetry/use-persistent-debug-logger';
import { ModalBackdropHost } from './ModalBackdropHost';
import { ModalStackContext } from './modal-stack-context';
import { useModalStackProviderValue } from './use-modal-stack-provider-value';

const MODAL_STACK_DEBUG_COMPONENT = 'ModalStackProvider/mobile-modal-stack';

export function ModalStackProvider({ children }: { children: ReactNode }): ReactNode {
  const modalDebugLogger = usePersistentDebugLogger({
    component: MODAL_STACK_DEBUG_COMPONENT,
    instanceId: MOBILE_TEAM_MODAL_DEBUG_INSTANCE_ID,
    metadata: {
      feature: MOBILE_TEAM_MODAL_DEBUG_FEATURE,
      source: MobileModalDebugSource.ModalStackProvider,
    },
  });
  const value = useModalStackProviderValue({ modalDebugLogger });

  return (
    <ModalStackContext.Provider value={value}>
      {children}
      <ModalBackdropHost />
    </ModalStackContext.Provider>
  );
}
